import {
  fetchCurrentOrgSubscription,
  setCurrentOrganizationsTariffesInfo,
} from "../store/tariffesSlice";

export const updateTariffes = async (userOrganizations, dispatch) => {
  const organizationsTariffes = {};

  for (let i = 0; i < userOrganizations.length; i++) {
    const orgId = userOrganizations[i].id;
    const orgTariffInfoResponse = await dispatch(
      fetchCurrentOrgSubscription({ orgId })
    );
    const orgTariffInfo = (!orgTariffInfoResponse.error && {
      ...orgTariffInfoResponse.payload,
    }) || {
      id: orgId,
      plan: null,
    };
    organizationsTariffes[orgId] = orgTariffInfo;
  }

  return await dispatch(
    setCurrentOrganizationsTariffesInfo(organizationsTariffes)
  );
};

export const formatPrice = (value) => {
  const num = Number(value);
  if (Number.isNaN(num)) return value;
  const [int, frac] = String(num).split(".");
  const grouped = int.replace(/\B(?=(\d{3})+(?!\d))/g, "\u00A0");
  return frac ? `${grouped}.${frac}` : grouped;
};
